export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/CarCertified.71f3121c.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};